import { LinearProgress } from "@mui/material";
import { ReactNode } from "react";

import { EntityType } from "@/core/api/generated/v1";

export interface BaseEntityListViewOwnProps {
  entityType: EntityType;
  /** Render children when init is done. */
  isIniting?: boolean;
  children: ReactNode;
}

export type BaseEntityListViewProps = BaseEntityListViewOwnProps;

/** Interface to be used by wrapper components that utilize this component. */
export interface BaseEntityListViewInheritableProps {
  typePlaceholder?: string;
}

export default function BaseEntityListView({
  entityType,
  isIniting,
  children,
}: BaseEntityListViewProps) {
  // ensure crucial data is loaded and init is done before rendering the form
  if (isIniting) {
    return <LinearProgress />;
  }

  return <>{children}</>;
}
